'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$30() {
  this.bgV = null;
  this.bgT = null;
  this.bgU = false;
  this.bgR = null;
  this.bgS = false;
  this.bgW = false;
  this.bgX = false;
  this.bgV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$30 as $c_Lpresto_PrestoRouter$$anon$30 };
$p = $c_Lpresto_PrestoRouter$$anon$30.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$30;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$30() {
}
export { $h_Lpresto_PrestoRouter$$anon$30 as $h_Lpresto_PrestoRouter$$anon$30 };
$h_Lpresto_PrestoRouter$$anon$30.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgV;
});
$p.t = (function() {
  if ((!this.bgU)) {
    this.bgT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgU = true;
  }
  return this.bgT;
});
$p.ae = (function() {
  if ((!this.bgS)) {
    this.bgR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgS = true;
  }
  return this.bgR;
});
$p.w = (function() {
  if ((!this.bgX)) {
    this.bgW = false;
    this.bgX = true;
  }
  return this.bgW;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$30, "presto.PrestoRouter$$anon$30", ({
  NW: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$30 as $d_Lpresto_PrestoRouter$$anon$30 };
//# sourceMappingURL=presto.-Presto-Router$$anon$30.js.map
